// extracted by mini-css-extract-plugin
export default {"prevent_scroll":"usePreventScroll_prevent_scroll__hBM96"};